// Libraries
import { initializeApp, setLogLevel } from 'firebase/app'
import { getAnalytics, initializeAnalytics, isSupported, setAnalyticsCollectionEnabled } from 'firebase/analytics'

// Utilities
import environment from '../utility/environmentUtils'
import logger from '../utility/loggerUtil'

class FirebaseWebUtil {
  /**
   * Allow firebase.app.App instance only to be created once
   * @type {firebase.app.App|null}
   */
  static #app = null

  /**
   * Initialize firebase SDK.
   */
  static async init () {
    try {
      const firebaseConfig = {
        apiKey: 'AIzaSyDHFJBfdZS2DvjJZmLe1KG1JcUPoSqbq58',
        authDomain: 'titlemax-express.firebaseapp.com',
        projectId: 'titlemax-express',
        storageBucket: 'titlemax-express.firebasestorage.app',
        messagingSenderId: '150217897590',
        appId: '1:150217897590:web:f8c363a0091103818d1157',
        measurementId: 'G-4XBPM2W0T1'
      }

      FirebaseWebUtil.#app = initializeApp(firebaseConfig, { automaticDataCollectionEnabled: true })

      if (environment.isLowerEnv()) {
        setLogLevel('verbose')
      }

      logger.debug(`Firebase instance: ${FirebaseWebUtil.#app.name}`)

      const isAnalyticsSupported = await isSupported()

      logger.debug(`Analytics supported: ${isAnalyticsSupported}`)

      if (isAnalyticsSupported) {
        const analytics = initializeAnalytics(FirebaseWebUtil.#app, { allow_ad_personalization_signals: true, allow_google_signals: true })
        setAnalyticsCollectionEnabled(analytics, true)
      }
    } catch (e) {
      logger.error('Error initializing Firebase', e)
    }
  }

  static getAnalyticInstance () {
    if (FirebaseWebUtil.#app === undefined) { // Only use for Firebase web
      return {}
    }

    logger.trace('getting analytic instance...')
    return getAnalytics()
  }
}

export default FirebaseWebUtil
